/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

const AudioVideoPlayers = require("./AudioVideoPlayers");
const ContactForm = require("./ContactForm");
const PageGalleries = require("./PageGalleries");
const Newsfeed = require("./Newsfeed");
const Maps = require("./Maps");

/**
 * Module for working with loop pagination.
 */

let attachLoopPagination = function () {
  let pageableLoopElements = document.querySelectorAll("ul[data-placeholder-id].pagination"),
    pos,
    length,
    element,
    fetchPlaceholderPage = function (link, placeholder, callback) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", link);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(placeholder, xhr.responseText);
        }
      };
      xhr.send();
    },
    reloadPlaceholderElements = function (placeholder, content) {
      let fragment,
        elements = document.querySelectorAll('[data-placeholder-id="' + placeholder + '"]'),
        parent = elements.item(0).parentElement,
        previous = elements.item(0).previousElementSibling,
        children,
        nextChild;
      Array.prototype.forEach.call(elements, function (element) {
        element.parentElement.removeChild(element);
      });

      // if (previous) {
      //     previous.insertAdjacentHTML('afterend', content);
      // } else {
      fragment = document.createDocumentFragment();
      fragment.appendChild(document.createElement("div")).innerHTML = content;
      reloadElementsEvents(fragment.querySelector("ul[data-placeholder-id]"));
      children = fragment.children.item(0).children;
      while ((nextChild = children.item(0)) !== null) {
        parent.appendChild(nextChild);
      }
      AudioVideoPlayers.initAudioPlayers(parent);
      AudioVideoPlayers.initVideoPlayers(parent);
      AudioVideoPlayers.initRemotePlayers(parent);
      ContactForm.initContactFormInContext(parent);
      PageGalleries.initGalleriesElements(parent);
      Newsfeed.initNewsfeedInContext(parent);
      Maps.initMaps(parent);
      // }
    },
    reloadElementsEvents = function (element) {
      element.addEventListener("click", function (event) {
        let target = event.target;
        if (target.nodeType === 1) {
          // Target must be a HTML element
          if (target.tagName === "LI") {
            fetchPlaceholderPage(target.children.item(0).getAttribute("data-link"), event.currentTarget.getAttribute("data-placeholder-id"), reloadPlaceholderElements);
          } else if (target.tagName === "A") {
            fetchPlaceholderPage(target.getAttribute("data-link"), event.currentTarget.getAttribute("data-placeholder-id"), reloadPlaceholderElements);
          }
        }
        event.preventDefault();
      });
    };
  for (pos = 0, length = pageableLoopElements.length; pos < length; pos++) {
    element = pageableLoopElements.item(pos);
    reloadElementsEvents(element);
  }
};
export { attachLoopPagination };